<template>
  <div>
    <v-dialog persistent v-model="show" max-width="760">
      <v-card>
        <v-card-title class="headline">Fracción arancelaria</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12"
                ><v-text-field
                autofocus
                  :error-messages="nombreErrors"
                  @input="$v.objetoFraccionA.Nombre.$touch()"
                  @blur="$v.objetoFraccionA.Nombre.$touch()"
                  v-model="objetoFraccionA.Nombre"
                  dense
                  label="Nombre"
                ></v-text-field
              ></v-col>
              <v-col cols="12"
                ><v-text-field
                  :error-messages="numClasificacionErrors"
                  @input="$v.objetoFraccionA.Num_clasificacion.$touch()"
                  @blur="$v.objetoFraccionA.Num_clasificacion.$touch()"
                  v-model="objetoFraccionA.Num_clasificacion"
                  dense
                  label="Número de clasificación"
                ></v-text-field
              ></v-col>
              <v-col cols="12"
                ><v-textarea
                  :error-messages="desEnErrors"
                  @input="$v.objetoFraccionA.Des_en.$touch()"
                  @blur="$v.objetoFraccionA.Des_en.$touch()"
                  v-model="objetoFraccionA.Des_en"
                  no-resize
                  rows="3"
                  dense
                  label="Descripción inglés"
                ></v-textarea
              ></v-col>
              <v-col cols="12"
                ><v-textarea
                  :error-messages="desEsErrors"
                  @input="$v.objetoFraccionA.Des_es.$touch()"
                  @blur="$v.objetoFraccionA.Des_es.$touch()"
                  v-model="objetoFraccionA.Des_es"
                  no-resize
                  dense
                  rows="3"
                  label="Descripción español"
                ></v-textarea
              ></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="cerrarModalFraccionA()" text>Cancelar</v-btn>
          <v-btn color="blue darken-1" @click="insertaFraccionA()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';

const nombreRegex = /^([a-zA-Z0-9ÁÉÍÓÚáéíóúÑñ ]{1,50})$/;
const numClasificacionRegex = /^([0-9]{4}[.][0-9]{2}[.][0-9]{4})$/;
const desEnRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){1,250})$/;
const desEsRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){0,300})$/;
export default {
  validations: {
    objetoFraccionA: {
      Nombre: {
        required,
        nombreValido(Nombre) {
          return nombreRegex.test(Nombre);
        },
      },
      Num_clasificacion: {
        required,
        numClasificacionValido(NumClasificacion) {
          return numClasificacionRegex.test(NumClasificacion);
        },
      },
      Des_en: {
        required,
        desEnValido(desEn) {
          return desEnRegex.test(desEn);
        },
      },
      Des_es: {
        required,
        desEsValido(desEs) {
          return desEsRegex.test(desEs);
        },
      },
    },
  },
  name: 'ModalNuevaFraccionA',
  methods: {
    cerrarModalFraccionA() {
      this.$emit('cerrarModalFraccion');
    },
    insertaFraccionA() {
      this.$v.$touch();
      if (this.$v.$invalid) {

      } else {
        this.voyAInsertar
          ? this.$emit('insertaFracciona', this.objetoFraccionA)
          : this.$emit('editarFracciona', this.objetoFraccionA);
      }
    },
  },
  mounted() {
    if (this.fraccionPasada.ID) {
      this.voyAInsertar = false;
      this.objetoFraccionA.Id = this.fraccionPasada.ID;
      this.objetoFraccionA.Nombre = this.fraccionPasada.NOMBRE;
      this.objetoFraccionA.Num_clasificacion = this.fraccionPasada.NUM_CLASIFICACION;
      this.objetoFraccionA.Des_en = this.fraccionPasada.DES_EN;
      this.objetoFraccionA.Des_es = this.fraccionPasada.DES_ES;
    }
  },
  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.objetoFraccionA.Nombre.$dirty) return errors;
      !this.$v.objetoFraccionA.Nombre.required && errors.push('El campo nombre es requerido.');
      !this.$v.objetoFraccionA.Nombre.nombreValido
        && errors.push('El campo nombre no tiene el formato correcto.');
      return errors;
    },
    numClasificacionErrors() {
      const errors = [];
      if (!this.$v.objetoFraccionA.Num_clasificacion.$dirty) return errors;
      !this.$v.objetoFraccionA.Num_clasificacion.required
        && errors.push('El campo número de clasificación es requerido.');
      !this.$v.objetoFraccionA.Num_clasificacion.numClasificacionValido
        && errors.push('El campo número de clasificación no tiene el formato correcto.');
      return errors;
    },
    desEsErrors() {
      const errors = [];
      if (!this.$v.objetoFraccionA.Des_es.$dirty) return errors;
      !this.$v.objetoFraccionA.Des_es.required
        && errors.push('El campo descripción en español es requerido.');
      !this.$v.objetoFraccionA.Des_es.desEsValido
        && errors.push('El campo descripción español no tiene el formato correcto.');
      return errors;
    },
    desEnErrors() {
      const errors = [];
      if (!this.$v.objetoFraccionA.Des_en.$dirty) return errors;
      !this.$v.objetoFraccionA.Des_en.required
        && errors.push('El campo descripción en inglés es requerido.');
      !this.$v.objetoFraccionA.Des_en.desEnValido
        && errors.push('El campo descripción inglés no tiene el formato correcto.');
      return errors;
    },
  },
  props: {
    fraccionPasada: Object,
    show: Boolean,
  },
  data: () => ({
    voyAInsertar: true,
    objetoFraccionA: {
      Nombre: '',
      Num_clasificacion: '',
      Des_en: '',
      Des_es: '',
    },
  }),
};
</script>
